import type { PropsWithChildren, ReactNode } from "react";
import { tv } from "tailwind-variants";

const timelineVariants = tv({
  slots: {
    list: "relative ml-1.5 flex flex-col gap-4 border-l border-line-strong py-1",
    item: "relative pl-5",
    dot: "absolute top-1.5 -left-[5px] size-2.5 rounded-full bg-line-strong ring-2 ring-surface",
    header: "flex flex-wrap items-center gap-2",
    time: "text-xs text-content-muted tabular-nums",
    description: "mt-1 text-sm break-all text-content",
  },
});

const { description, dot, header, item, list, time } = timelineVariants();

type TimelineProps = {
  label: string;
};

export const Timeline = ({ children, label }: PropsWithChildren<TimelineProps>) => {
  return (
    <ol aria-label={label} className={list()}>
      {children}
    </ol>
  );
};

type TimelineItemProps = {
  dateTime: string;
  time: string;
  badge: ReactNode;
  description?: string | null;
};

export const TimelineItem = ({
  badge,
  dateTime,
  description: text,
  time: formattedTime,
}: TimelineItemProps) => {
  return (
    <li className={item()}>
      <span aria-hidden="true" className={dot()} />

      <div className={header()}>
        <time className={time()} dateTime={dateTime}>
          {formattedTime}
        </time>

        {badge}
      </div>

      {text ? <p className={description()}>{text}</p> : null}
    </li>
  );
};
